var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Konfig",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30.084,
    viewBox: "0 0 30 30.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Konfig .cls-1 {\n        fill: #f5f5f5;\n      }\n\n      #Konfig .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30.084
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.113,14.921c0,.04.006.08.006.121A13.119,13.119,0,1,1,15,1.881c.04,0,.08.007.12.007V.007C15.08.006,15.04,0,15,0A15.042,15.042,0,1,0,30,15.042c0-.041-.006-.081-.006-.121Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.358,7.475l-9.85,9.85-.548-.546,9.851-9.851Zm3.873-.016L15.173,20.517,9.656,21.63l1.113-5.516L23.828,3.055ZM12.193,16.878l-.559,2.773,2.774-.56L26.042,7.459,23.827,5.243Z",
    transform: "translate(-0.575 -0.182)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c64f8e3fd151e1d9c91d19f210804fdb.svg";
export { ForwardRef as ReactComponent };